module.exports = __webpack_public_path__ + "2962b1893bb32db6b1525c83ea81eb98.svg";